export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    holdList: [
      {
        holdIdx: 1,
        salesDate: "2023-11-27",
        salesTime: "12:15:00",
        totalUprc:22000,
        totalDiscount:500,
        receivedUprc:0,
        menuArr: [
          {
            discount: 500,
            groupIdx: 1,
            menuIdx: 2,
            name: "02 Garlic paghetti",
            optionList: [
              {
                selectItemCd: "10000147",
                selectItemCnt: 1,
                selectItemDiscount: 0,
                selectItemNm: "XL 사이즈",
                selectItemPrice: 3000,
              },
            ],
            price: 19000,
            qty: 1,
          },
        ],
      },
    ],
  },
};
